import { fetchApi } from '@/services/api-client';

export const PARENT_PROFILE_CHANGES_PATH = '/admin/parent-profile-changes';

/**
 * The admin app shares no types with the API, so this mirrors the API's own
 * ParentProfileField enum by hand rather than importing it.
 */
export type ParentProfileField =
  'fullName' | 'phone' | 'address' | 'occupation' | 'dateOfBirth' | 'nationalities' | 'email';

/**
 * `before`/`after` are already display-ready strings from the API (nationalities as
 * "Thailand, Italy", dates as YYYY-MM-DD) — render them as-is, never re-resolve them.
 */
export type ProfileFieldChange = {
  field: ParentProfileField;
  before: string | null;
  after: string | null;
};

export type ParentProfileChangeRow = {
  id: string;
  parentId: string;
  parentName: string;
  changes: ProfileFieldChange[];
  createdAt: string;
  reviewedAt: string | null;
  reviewedByName: string | null;
};

export type ParentProfileChangesFilters = {
  page?: number;
  limit?: number;
  reviewed?: 'true' | 'false' | 'all';
};

export type ParentProfileChangeListResult = {
  data: ParentProfileChangeRow[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export const parentProfileChangesApi = {
  list: (filters: ParentProfileChangesFilters = {}) => {
    const qs = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined) qs.append(key, String(value));
    }
    const s = qs.toString();
    return fetchApi<ParentProfileChangeListResult>(`${PARENT_PROFILE_CHANGES_PATH}${s ? `?${s}` : ''}`);
  },
  unreviewedCount: () => fetchApi<{ count: number }>(`${PARENT_PROFILE_CHANGES_PATH}/unreviewed-count`),
  review: (id: string) => fetchApi<void>(`${PARENT_PROFILE_CHANGES_PATH}/${id}/review`, { method: 'POST' }),
  reviewAll: () => fetchApi<void>(`${PARENT_PROFILE_CHANGES_PATH}/review-all`, { method: 'POST' }),
};
